import { TempAuthContext } from "components/auth/TempAuthProvider/TempAuthProvider";
import BrowserCookies from "js-cookie";
import { useCallback, useContext, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadUser, logout as logoutAction } from "redux/actions/authActions";
import { AppState } from "redux/store";

export interface Auth {
    token: string | null;
    isAuthenticated: boolean;
    isLoading: boolean;
    user: { [x: string]: any };
    error: boolean;
    showLogin: boolean;
}

interface AuthActions {
    loginByToken: (token: string) => void;
    logout: () => void;
    relativeInClub: (clubSlug: string | undefined) => boolean;
}

export const useAuth = (): Auth & AuthActions => {
    const dispatch = useDispatch();
    const auth = useSelector((state: AppState) => state.auth as Auth);
    const {token, user:_user} = useContext(TempAuthContext);

    const user = useMemo(() => _user || auth.user , [_user,auth]);

    const relativeInClub = useCallback((clubSlug: string | undefined): boolean => {
        if (!clubSlug) return false;
        return auth.user?.clubs?.some((club) => club.slug === clubSlug) ?? false;
    }, [auth.user?.clubs]);

    const loginByToken = (token: string) => {
        BrowserCookies.set("token", token);
        dispatch(loadUser());
    };

    const logout = () => {
        dispatch(logoutAction());
    };

    return { ...auth, isAuthenticated: (!!token && !!user) ? true : auth.isAuthenticated, user, token: token ?? auth.token, loginByToken, logout, relativeInClub };
};

export default useAuth;
